__webpack_require__.p = "https://csgo.cdn.pureskill.app/";